import { v4 as uuidv4 } from 'uuid';
import { LocalStoreHandler } from './local-storage-handler';
import { ConfigStore } from '../store/config';
import type { IRequestSearch } from '../interfaces/request-search-question.interface';
import { get } from 'svelte/store';

// Keep load and chat requests correlated even when browser storage is unavailable.
let fallbackUserId: string | undefined;

export const UserStateHelper = {
  getUserId: (): string => {
    try {
      const storedUserId: string = LocalStoreHandler.get()?.userId;
      if (storedUserId) {
        fallbackUserId = storedUserId;
        return storedUserId;
      }
      fallbackUserId ??= uuidv4();
      LocalStoreHandler.update({ userId: fallbackUserId });
    } catch {
      fallbackUserId ??= uuidv4();
    }
    return fallbackUserId;
  },
  setRequestProperties: (params: IRequestSearch): IRequestSearch => {
    if (!params.user_id) params.user_id = UserStateHelper.getUserId();
    if (!params.user_tz)
      params.user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!params.attributes) params.attributes = {};
    if (
      !params.attributes.date &&
      (get(ConfigStore)?.injectDatetime == 'always' ||
        (params.response_to_question_id &&
          get(ConfigStore)?.injectDatetime == 'interaction') ||
        (!params.response_to_question_id &&
          get(ConfigStore)?.injectDatetime == 'greeting'))
    )
      params.attributes.date = Date();
    if (!params.url) params.url = window?.location?.href;
    return params;
  },
};
